<template>
    <div>
        <MainTitle
            v-if="plotTitle"
            :data="data"
            :screenProperties="screenProperties"
            :title="plotTitle"
            :prices="{
                'total': totalPrice,
                'annex': annexPrice,
                'plot': plotPrice
            }"
            :plotPrice="plotPrice"
            :annexPrice="annexPrice"
            :type="type"
        />

        <Tags
            v-if="plotTags.length && !screenProperties.isTinyScreen && allowedTypes.includes(type)"
            :tags="plotTags"
        />

        <Details
            v-if="hasDetails"
            :details="data.details"
            :screenProperties="screenProperties"
            :type="type"
            :width="cardWidth"
        />
    </div>
</template>

<script>
    import Details from '@/components/plotInformation/components/Details';
    import MainTitle from '@/components/plotInformation/components/MainTitle';
    import Tags from '@/components/plotInformation/components/Tags';

    export default {
        name: 'PlotBody',
        components: {
            Details,
            MainTitle,
            Tags
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            cardWidth: {
                type: [Number, String],
                required: false
            },
            screenProperties: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                allowedTypes: [
                    'plot',
                    'plot-grid'
                ]
            }
        },
        computed: {
            hasDetails() {
                let details = this.$props.data.details ? this.$props.data.details.filter(plotDetail => plotDetail.value != '') : [];
                return details.length > 0;
            },
            plotTitle() {
                return this.$props.data ? this.$props.data.text : null;
            },
            annexPrice() {
                let price = this.$props.data.details ? this.getPlotDetailById('annexPrice') : null;
                return price ? price.value : null;
            },
            plotPrice() {
                let price = this.$props.data.details ? this.getPlotDetailById('lotPrice') : null;
                return price ? price.value : null;
            },
            totalPrice() {
                let price = this.$props.data.details ? this.getPlotDetailById('totalPrice') : null;
                return price ? price.value : null;
            },
            plotTags() {
                let tagList = [];
                let tagDetails = this.getPlotDetailById('tags');
                if (tagDetails !== null) {
                    let tags = Object.entries(tagDetails.tags);
                    tags.forEach(tag => {
                        tagList.push({
                            name: tag[0],
                            color: tag[1].color
                        });
                    });
                }
                return tagList;
            }
        },
        methods: {
            getPlotDetailById(detailId) {
                if (this.$props.data.details) {
                    let detail = this.$props.data.details.filter(plotDetail => plotDetail.id === detailId);
                    if (detail.length)
                        return detail[0];
                    return null;
                }
                return null;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/plotInformation/layout/PlotBody.vue